import axios from "axios";
import { config } from "../shared/app.config";
import store from "../store";

const RESOURCE_NAME = "/customers";

export default {
  getListCustomers(search) {
    const params = {};
    if (search) {
      params["name"] = search;
    }

    const username = store.getters["auth/getCurrentUsername"];
    const user = store.getters["auth/getUser"];

    console.log(JSON.stringify(user));

    if (user.rol_id == 2) {
      return axios.get(
        `${config.webApiBase + RESOURCE_NAME}/agente/${user.id_agente}`,
        { params }
      );
    }

    return axios.get(
      `${config.webApiBase + RESOURCE_NAME}/comercial/${username}`,
      { params }
    );
  },
  getListCustomersAdmin(search) {
    const params = {};
    if (search) {
      params["name"] = search;
    }

    const username = store.getters["auth/getCurrentUsername"];

    /*  return axios.get(`${config.webApiBase + RESOURCE_NAME}/all/${username}`, {
      params,
    }); */

    return axios.get(
      `${config.webApiBase + RESOURCE_NAME}/comercial/${username}`,
      { params }
    );
  },
  getCustomerLogged(search) {
    const params = {};
    if (search) {
      params["codcli"] = search;
    }

    return axios.get(`${config.webApiBase + RESOURCE_NAME}`, { params });
  },
};
